module.exports = __webpack_public_path__ + "img/daizy_water.b67c1077.jpg";